import { Fragment } from "react";

function AddressSuggestionPreview({
  userAddress,
  suggestedAddress,
  handleSelect,
}) {
  const capitalizeValue = (value) => {
    if (!value || typeof value !== 'string') return value || '';
    return value.split('_').map(word => word.toUpperCase()).join(' ');
  };

  const formatAddressString = (addr) => {
    const parts = [];
    
    if (addr.address) {
      parts.push(capitalizeValue(addr.address));
    }
    
    if (addr.suiteAddress) {
      parts.push(capitalizeValue(addr.suiteAddress));
    }
    
    if (addr.city) {
      parts.push(capitalizeValue(addr.city));
    }
    
    if (addr.stateAddress) {
      parts.push(capitalizeValue(addr.stateAddress));
    }
    
    if (addr.zipCode) {
      parts.push(capitalizeValue(addr.zipCode));
    }
    
    if (addr.country) {
      parts.push(capitalizeValue(addr.country));
    } else {
      parts.push("United States");
    }
    
    return parts.join(", ");
  };

  return (
    <Fragment>
      <div className="addresspreview-container">
        <div className="addresspreview-item">
          <div className="addresspreview-header">
            <h4 className="addresspreview-title">Suggested (Recommended)</h4>
            <div className="addresspreview-actions">
              <button
                type="button"
                className="cta-button secondary"
                onClick={() => handleSelect(suggestedAddress)}
                aria-label="Select suggested address"
              >
                Select
              </button>
            </div>
          </div>
          <div className="addresspreview-content">
            <span className="addresspreview-text">{formatAddressString(suggestedAddress)}</span>
          </div>
        </div>
        <div className="addresspreview-item">
          <div className="addresspreview-header">
            <h4 className="addresspreview-title">Your Entered</h4>
            <div className="addresspreview-actions">
              <button
                type="button"
                className="cta-button secondary"
                onClick={() => handleSelect(userAddress)}
                aria-label="Select your entered address"
              >
                Select
              </button>
            </div>
          </div>
          <div className="addresspreview-content">
            <span className="addresspreview-text">{formatAddressString(userAddress)}</span>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default AddressSuggestionPreview;
